import { OFFER_DETAILS } from './constants';

export function openOfferDetails(data) {
  return {
    type: OFFER_DETAILS.OPEN,
    data,
  };
}

export function closeOfferDetails(data) {
  return {
    type: OFFER_DETAILS.CLOSE,
    data,
  };
}
